import { useBeforeUnload, useBlocker } from 'react-router';
import { useCallback, useEffect } from 'react';
import useIsMountedRef from '@/services/useIsMountedRef';

export const useDirtyFormBlocker = (isFormDirty = false) => {
    // https://github.com/remix-run/react-router/issues/11430
    const isMountedRef = useIsMountedRef();
    const enabled = isFormDirty && isMountedRef.current;
    const blocker = useBlocker(({ currentLocation, nextLocation }) => {
        const navAway = currentLocation.pathname !== nextLocation.pathname;
        return navAway && enabled;
    });

    // After we submit the form, the form is in a clean state again, but we will be blocked. We should prevent this
    useEffect(() => {
        if (!enabled && blocker.state === 'blocked') {
            blocker.proceed();
        }
    }, [enabled, blocker]);

    // When reloading, warn the user if the form is dirty
    useBeforeUnload(
        useCallback(
            (event) => {
                if (enabled) {
                    event.preventDefault();
                    event.returnValue = true; // Legacy support
                    return true;
                }
            },
            [enabled],
        ),
    );

    return blocker;
};
